<template>
  <button
    class="read-more btn-link"
    @click="
      () => {
        $emit('readMore', !toggleText);
      }
    "
  >
    {{ toggleText ? "Show All" : "Show Less" }}
    <i :class="toggleText ? 'icon arrow down' : 'icon arrow alternate up'"></i>
  </button>
</template>
<script>
export default {
  props: {
    toggleText: Boolean,
  },
};
</script>
